import React, { useRef, useState } from 'react'
import './Contact.css'
import { PaperAirplaneIcon } from '@heroicons/react/16/solid'
import tick from '../../assets/images/tick.png'

const Contact = () => {
    const formRef=useRef(null);
    const [submitted,setSubmitted]=useState(false);

    const handleSubmit=(e)=>{
        e.preventDefault();
        fetch('https://getform.io/f/akkgxwka',{
            method:'POST',
            body:new FormData(formRef.current),
        })
        .then(response=>{
            if(response.ok){
                setSubmitted(true);
                formRef.current.reset();
                setTimeout(()=>setSubmitted(false),4000);
            }
            else{
                console.error('Form submission error');
            }
        })
        .catch(error=>console.error('Form submission error',error));
    };

  return (
    <section className="contact">
        <div className="content">
          <span className="eyebrow">Get in touch</span>
          <h2 className="heading">Contact <span className='text-yellow-400'>me</span></h2>
          <p className="body-copy mt-3">Feel free to get in touch with me.</p>
        </div>
        <div className="contact_container">
            <div className="contactInfo">
                <div className="box">
                    <div className="icon"><i className="fa-solid fa-map"></i></div>
                    <div className="text">
                        <h3>Address</h3>
                        <p>Madi-09,<br/>Chitwan, Nepal</p>
                    </div>
                </div>

                <div className="box">
                    <div className="icon"><i className="fa-solid fa-phone"></i></div>
                    <div className="text">
                        <h3>Phone</h3>
                        <p>+977 9866028826</p>
                    </div>
                </div>

                <div className="box">
                    <div className="icon"><i className="fa-regular fa-envelope"></i></div>
                    <div className="text">
                        <h3>Email</h3>
                        <a className="contact_link" href="mailto:contactuniqueadhikari@gmail.com">contactuniqueadhikari@<wbr />gmail.com</a>
                    </div>
                </div>
            </div>
            
            <div className="contactForm">
                <form ref={formRef} onSubmit={handleSubmit}>
                    <h2>Send Message</h2>
                    <div className="inputBox">
                        <input type="text" name="fullName" required />
                        <span>Full Name</span>
                    </div>

                    <div className="inputBox">
                        <input type="email" name="email" required />
                        <span>Email</span>
                    </div>

                    <div className="inputBox">
                        <textarea name="message" required></textarea>
                        <span>Type your Message...</span>
                    </div>

                    <div className='relative w-[100%] mt-[10px]'>
                        <button type='submit' className='h-[44px] px-[1.25rem] hover:bg-yellow-400 transition-colors duration-150 text-[14px] font-semibold bg-[#55e6a5] text-[#121121] inline-flex gap-2 rounded-md items-center justify-center'>
                            Send
                            <PaperAirplaneIcon className='w-4 h-4' />
                        </button>
                        
                    </div>
                </form>
                
            </div>
        </div>

        {submitted && (
        <div className='popup'>
            <img src={tick} alt="" />
            <h2>Thank you!</h2>
            <p>Your message has been sent. I'll get back to you soon.</p>
            <button type='button' onClick={()=>setSubmitted(false)}>OK</button>
        </div>
        )}
    </section>
  )
}

export default Contact
